import {
  RecoveryPhraseType,
  RecoveryPhraseValidator,
} from "@/schemas/recoveryKey";
import { ArrowLeft } from "lucide-react";
import PhraseForm from "./PhraseForm";

interface BaseConfirmPhraseStepProps<ValidationParams> {
  title: string;
  description: string;
  validator: RecoveryPhraseValidator<ValidationParams>;

  onSubmit: (data: RecoveryPhraseType) => Promise<void>;
  onPrevious?: () => void;
  onClose?: () => void;
}
export default function BaseConfirmPhraseStep<ValidationParams>({
  title,
  description,
  validator,
  onSubmit,
  onPrevious,
  onClose,
}: BaseConfirmPhraseStepProps<ValidationParams>) {
  return (
    <div className="flex size-full flex-col items-center justify-center gap-4">
      <h1 className="flex items-center self-start text-lg">
        <ArrowLeft className="mr-2 cursor-pointer" onClick={onPrevious} />
        {title}
      </h1>

      <p className="w-full text-sm font-light opacity-50">{description}</p>

      <PhraseForm onSubmit={onSubmit} onClose={onClose} validator={validator} />
    </div>
  );
}
